/* GCS Produktseite – Relaunch David (Baustein 4)
   Custom Elements: <gcs-gallery>, <gcs-product>, <gcs-sticky-buy>, <gcs-product-recommendations>.
   Warenkorb nur über GCS.cart.add (assets/gcs-cart.js, Bauvertrag 6). Dawns product-form.js wird nicht geladen.
   Rabattanzeige = Kaching-Logik (Prozent pro Position, auf Cent gerundet), nur Anzeige. Summen im Warenkorb aus /cart.js. */
(() => {
  const GCS = (window.GCS = window.GCS || {});
  if (GCS.pdpLoaded) return;
  GCS.pdpLoaded = true;

  const money = (cents) =>
    GCS.formatMoney ? GCS.formatMoney(cents) : (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* Gesamtpreis einer Pack-Stufe: Positionspreis minus Prozent, auf Cent gerundet (wie Shopify pro Position) */
  const packTotal = (price, n, tiers) => {
    const line = price * n;
    const key = Math.min(Math.max(n, 1), 4);
    const pct = n >= 2 ? Number((tiers || {})[key] || 0) : 0;
    return line - Math.round((line * pct) / 100);
  };

  /* ------------------------------------------------------------------ */
  /* <gcs-gallery>                                                        */
  /* ------------------------------------------------------------------ */
  class GcsGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-gcs-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.index = 0;
      this.dots = Array.from(this.querySelectorAll('[data-gcs-dots] [data-gcs-goto]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gcs-thumbs] [data-gcs-goto]'));
      this.prev = this.querySelector('[data-gcs-prev]');
      this.next = this.querySelector('[data-gcs-next]');
      this.dialog = this.querySelector('[data-gcs-zoom-dialog]');

      if (this.slides.length > 1 && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.setActive(Number(entry.target.dataset.index));
              }
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      this.addEventListener('click', (event) => {
        const go = event.target.closest('[data-gcs-goto]');
        if (go) {
          this.goTo(Number(go.dataset.gcsGoto));
          return;
        }
        if (event.target.closest('[data-gcs-prev]')) return this.goTo(this.index - 1);
        if (event.target.closest('[data-gcs-next]')) return this.goTo(this.index + 1);
        const zoom = event.target.closest('[data-gcs-zoom]');
        if (zoom) this.openZoom(Number(zoom.dataset.gcsZoom));
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        /* Fokus wandert mit, damit Bild und Fokus übereinstimmen (Impeccable P4) */
        const target = this.slides[this.index] && this.slides[this.index].querySelector('button, video, iframe');
        if (target && this.track.contains(document.activeElement)) target.focus({ preventScroll: true });
      });

      /* Impeccable P4: Tastaturfokus (Tab) auf einem Bild außerhalb des sichtbaren Ausschnitts scrollt den Track mit */
      this.track.addEventListener('focusin', (event) => {
        const slide = event.target.closest('[data-index]');
        if (!slide || slide.parentElement !== this.track) return;
        const i = Number(slide.dataset.index);
        if (i !== this.index || Math.abs(this.track.scrollLeft - slide.offsetLeft) > 2) this.goTo(i, { smooth: false });
      });

      this.initZoom();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    setActive(index) {
      if (Number.isNaN(index) || index === this.index) return;
      this.index = index;
      const mark = (list) =>
        list.forEach((el, i) => (i === index ? el.setAttribute('aria-current', 'true') : el.removeAttribute('aria-current')));
      mark(this.dots);
      mark(this.thumbs);
      if (this.prev) this.prev.disabled = index <= 0;
      if (this.next) this.next.disabled = index >= this.slides.length - 1;
      const thumb = this.thumbs[index];
      const rail = thumb && thumb.parentElement;
      if (rail && (rail.scrollWidth > rail.clientWidth || rail.scrollHeight > rail.clientHeight)) {
        const vertical = rail.scrollHeight > rail.clientHeight;
        rail.scrollTo({
          [vertical ? 'top' : 'left']: (vertical ? thumb.offsetTop : thumb.offsetLeft) - 8,
          behavior: reduceMotion() ? 'auto' : 'smooth',
        });
      }
      this.slides.forEach((slide, i) => {
        if (i !== index) slide.querySelectorAll('video').forEach((v) => !v.paused && v.pause());
      });
    }

    goTo(index, { smooth = true } = {}) {
      if (!this.slides || !this.slides.length) return;
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const slide = this.slides[target];
      this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduceMotion() ? 'smooth' : 'auto' });
      this.setActive(target);
    }

    /* Variantenbild: springt zum Medium mit dieser ID (falls es in der Galerie ist) */
    showMedia(mediaId) {
      if (!mediaId || !this.slides) return;
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0 && i !== this.index) this.goTo(i);
    }

    initZoom() {
      if (!this.dialog) return;
      this.zoomTrack = this.dialog.querySelector('[data-gcs-zoom-track]');
      this.zoomSlides = this.zoomTrack ? Array.from(this.zoomTrack.children) : [];
      this.zoomIndexEl = this.dialog.querySelector('[data-gcs-zoom-index]');
      this.zoomIndex = 0;
      if ('IntersectionObserver' in window && this.zoomTrack) {
        this.zoomObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.zoomIndex = Number(entry.target.dataset.index);
                if (this.zoomIndexEl) this.zoomIndexEl.textContent = String(this.zoomIndex + 1);
              }
            });
          },
          { root: this.zoomTrack, threshold: [0.6] }
        );
        this.zoomSlides.forEach((s) => this.zoomObserver.observe(s));
      }
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-gcs-zoom-close]')) return this.closeZoom();
        if (event.target.closest('[data-gcs-zoom-prev]')) return this.zoomTo(this.zoomIndex - 1);
        if (event.target.closest('[data-gcs-zoom-next]')) return this.zoomTo(this.zoomIndex + 1);
        const img = event.target.closest('.gcs-zoom__img');
        if (img && window.matchMedia('(hover: hover) and (pointer: fine)').matches) this.toggleMagnify(img, event);
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.zoomTo(this.zoomIndex + 1);
        if (event.key === 'ArrowLeft') this.zoomTo(this.zoomIndex - 1);
      });
      this.dialog.addEventListener('close', () => {
        GCS.unlockScroll && GCS.unlockScroll();
        this.dialog.querySelectorAll('.is-magnified').forEach((el) => el.classList.remove('is-magnified'));
        this.goTo(this.zoomIndex, { smooth: false });
        if (this.zoomOpener && document.contains(this.zoomOpener)) this.zoomOpener.focus({ preventScroll: true });
      });
    }

    openZoom(index) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.zoomOpener = document.activeElement;
      this.dialog.showModal();
      GCS.lockScroll && GCS.lockScroll();
      this.zoomIndex = index;
      if (this.zoomIndexEl) this.zoomIndexEl.textContent = String(index + 1);
      const slide = this.zoomSlides[index];
      if (slide) this.zoomTrack.scrollLeft = slide.offsetLeft;
      const close = this.dialog.querySelector('[data-gcs-zoom-close]');
      if (close) close.focus({ preventScroll: true });
    }

    zoomTo(index) {
      const target = Math.max(0, Math.min(index, this.zoomSlides.length - 1));
      const slide = this.zoomSlides[target];
      if (slide) this.zoomTrack.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    closeZoom() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    toggleMagnify(img, event) {
      const on = !img.classList.contains('is-magnified');
      if (on) {
        const rect = img.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      }
      img.classList.toggle('is-magnified', on);
    }
  }

  /* ------------------------------------------------------------------ */
  /* <gcs-product>                                                        */
  /* ------------------------------------------------------------------ */
  class GcsProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const json = this.querySelector('[data-gcs-product-json]');
      if (!json) return;
      try {
        this.data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      this._ready = true;
      this.sectionId = this.dataset.section;
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.idInput = this.querySelector('[data-gcs-variant-input]');
      this.groups = Array.from(this.querySelectorAll('[data-gcs-option]'));
      this.packs = this.querySelector('[data-gcs-packs]');
      this.qtyInput = this.querySelector('[data-gcs-qty]');
      this.btn = this.querySelector('[data-gcs-atc]');
      this.btnLabel = this.querySelector('[data-gcs-atc-label]');
      this.btnPrice = this.querySelector('[data-gcs-atc-price]');
      this.btnPp = this.querySelector('[data-gcs-atc-pp]');
      this.hasPp = !!this.btnPp;
      /* Black Month (Review-Call 24.10.2026): Streichpreis im Button (nur wenn Liquid das Element ausgibt) und
         Einheit „Pack/Packs“ am Mengen-Wähler */
      this.btnWas = this.querySelector('[data-gcs-atc-was]');
      this.hasWas = !!this.btnWas;
      this.qtyUnit = this.querySelector('[data-gcs-qty-unit]');
      /* A4: Preis im Button (Section-Setting show_price_in_button) – „Aktion · Gesamtpreis · Preis pro Paar“ */
      this.inline = this.hasAttribute('data-price-in-button');
      this.errorEl = this.querySelector('[data-gcs-atc-error]');
      this.bisBtn = this.querySelector('[data-gcs-bis]');
      this.note = this.querySelector('[data-gcs-note]') || this.parentElement.querySelector('[data-gcs-note]');
      this.noteText = this.querySelector('[data-gcs-note-text]');
      this.headPrice = this.querySelector('[data-gcs-head-price]');
      this.gallery = this.querySelector('gcs-gallery');
      /* QA: Startwert = Medium der sichtbaren Folie (sonst galt z. B. bei JUNIOR PACK DINO das Bild der
         ersten Variante als „schon gezeigt“, und die Wahl dieser Größe sprang nicht zu ihrem Bild) */
      const firstSlide = this.gallery && this.gallery.querySelector('[data-gcs-track] > [data-media-id]');
      this.lastMedia = firstSlide ? String(firstSlide.dataset.mediaId) : null;

      this.selected = this.data.options.map((_, i) => {
        const group = this.groupAt(i);
        const checked = group && group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      /* Produkte ohne Auswahl-UI (nur Standardvariante): Werte aus der ersten Variante */
      if (!this.groups.length && this.data.variants.length) this.selected = this.data.variants[0].o.slice();

      this.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        const group = input.closest('[data-gcs-option]');
        if (group) {
          const pos = Number(group.dataset.gcsOption) - 1;
          this.selected[pos] = input.value;
          this.clearAttention(group);
          this.update({ user: true, changed: pos });
          return;
        }
        if (input.name === 'quantity') {
          this.update({ user: true });
          this.snapDeal(input);
        }
      });

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-gcs-step]');
        if (step && this.qtyInput) {
          const next = Math.max(1, Math.min(99, (parseInt(this.qtyInput.value, 10) || 1) + Number(step.dataset.gcsStep)));
          this.qtyInput.value = String(next);
          this.update({ user: true });
        }
      });
      if (this.qtyInput) {
        this.qtyInput.addEventListener('input', () => this.update({ user: true }));
        this.qtyInput.addEventListener('blur', () => {
          const v = Math.max(1, Math.min(99, parseInt(this.qtyInput.value, 10) || 1));
          this.qtyInput.value = String(v);
          this.update({ user: true });
        });
      }

      /* Fremd-Skripte (z. B. Kaching) schreiben Preis/Label in den Button: unseren Stand wiederherstellen */
      if (this.btn && 'MutationObserver' in window) {
        /* Eigene Zähl-Animation im Preis pro Paar löst keinen Neuaufbau aus */
        this.guard = new MutationObserver((records) => {
          if (this.btnPp && records.every((r) => this.btnPp.contains(r.target))) return;
          this.paintButton();
        });
        this.guard.observe(this.btn, { childList: true, characterData: true, subtree: true });
      }

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.buy();
        });
      }

      this.update({ user: false });
      this.reserveNote();
      this.quietApps();
      this.initBack();
      this.markGuaranteeLinks();
    }

    /* Runde D: Garantie-Links im Seiteninhalt öffnen das Garantie-Pop-up (gcs-global.js, [data-gcs-guarantee-open]),
       auch in Admin-Texten (Beschreibung, FAQ-Antworten), damit niemand die PDP für die Garantie verlässt. */
    markGuaranteeLinks() {
      const target = (GCS.settings && GCS.settings.guaranteeUrl) || '/pages/garantie';
      let path;
      try {
        path = new URL(target, window.location.origin).pathname.replace(/\/$/, '');
      } catch (e) {
        return;
      }
      const scope = document.getElementById('MainContent') || document.querySelector('main') || document;
      scope.querySelectorAll('a[href]:not([data-gcs-guarantee-open])').forEach((a) => {
        try {
          const url = new URL(a.getAttribute('href'), window.location.href);
          if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === path) a.setAttribute('data-gcs-guarantee-open', '');
        } catch (e) {
          /* ignorieren */
        }
      });
    }

    /* Breadcrumb „Alle Produkte › Kategorie“ (Review-Call 24.10.2026, snippets/gcs-pdp-back.liquid): War die vorige
       Seite eine Collection derselben Domain, führt die Kategorie genau dorthin (inkl. Filter, Sortierung, Seite) und
       geht per history.back() zurück, damit Scroll-Position und nachgeladene Produkte erhalten bleiben. Kam man von
       /collections/all, macht das „Alle Produkte“ so. Unbekannte Collection: Liquid-Ziel (Haupt-Kategorie) bleibt. */
    initBack() {
      const link = this.querySelector('[data-gcs-back]');
      if (!link) return;
      let ref = null;
      try {
        ref = document.referrer ? new URL(document.referrer) : null;
      } catch (e) {
        ref = null;
      }
      if (!ref || ref.origin !== window.location.origin) return;
      const match = /^(?:\/[a-z]{2}(?:-[a-z]{2,4})?)?\/collections\/([^/]+)\/?$/i.exec(ref.pathname);
      if (!match) return;
      let handle = match[1];
      try {
        handle = decodeURIComponent(handle);
      } catch (e) {
        /* Handle bleibt roh */
      }
      const target = ref.pathname + ref.search;
      const goBack = (el) => {
        el.href = target;
        el.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          /* Neuer Tab ohne Verlauf: normaler Link */
          if (window.history.length < 2) return;
          event.preventDefault();
          let left = false;
          window.addEventListener('pagehide', () => (left = true), { once: true });
          const here = window.location.href;
          window.history.back();
          /* Führt back() nicht weg (fremder Verlauf), normal zur Collection */
          setTimeout(() => {
            if (!left && window.location.href === here) window.location.assign(target);
          }, 1200);
        });
      };
      if (handle === 'all' || handle === 'alle-produkte') {
        const all = this.querySelector('[data-gcs-crumb-all]');
        if (all) goBack(all);
        return;
      }
      let labels = {};
      try {
        labels = JSON.parse(link.dataset.gcsBackLabels || '{}');
      } catch (e) {
        labels = {};
      }
      if (!labels[handle]) return;
      const labelEl = link.querySelector('[data-gcs-back-label]');
      if (labelEl) labelEl.textContent = labels[handle];
      const cat = link.closest('[data-gcs-crumb-cat]');
      if (cat) cat.hidden = false;
      goBack(link);
    }

    /* G2 (Orchestrator 02.10.2026): solange der Kaufbereich mobil im Bild ist (Preis bis Kaufen-Button und
       Social-Trust), html.gcs-quiet-apps setzen, sonst entfernen. gcs-base.css blendet dann den Klaviyo-Teaser aus
       (Cookie-Symbol bleibt), damit nichts über Preis, Pack-Kacheln oder Button liegt. */
    quietApps() {
      const parts = [
        this.querySelector('.gcs-pdp__head'),
        this.querySelector('.gcs-buy'),
        this.querySelector('[data-gcs-note]'),
        this.querySelector('.gcs-pbar'),
      ].filter(Boolean);
      if (!parts.length || !('IntersectionObserver' in window)) return;
      const mq = window.matchMedia('(max-width: 989px)');
      const seen = new Set();
      const apply = () => document.documentElement.classList.toggle('gcs-quiet-apps', seen.size > 0 && mq.matches);
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
        apply();
      });
      parts.forEach((el) => io.observe(el));
      if (mq.addEventListener) mq.addEventListener('change', apply);
    }

    groupAt(i) {
      return this.groups.find((g) => Number(g.dataset.gcsOption) === i + 1);
    }

    get quantity() {
      if (this.data.mode === 'pack' && this.packs) {
        const checked = this.packs.querySelector('input[name="quantity"]:checked');
        return checked ? Math.max(1, parseInt(checked.value, 10) || 1) : 1;
      }
      if (this.qtyInput) return Math.max(1, Math.min(99, parseInt(this.qtyInput.value, 10) || 1));
      return 1;
    }

    /* Varianten, die zu allen gewählten Optionen passen (ignoriert nicht gewählte) */
    candidates(skipPos = -1) {
      return this.data.variants.filter((v) =>
        this.selected.every((val, i) => i === skipPos || val === null || v.o[i] === val)
      );
    }

    get variant() {
      if (this.selected.some((v) => v === null)) return null;
      return this.data.variants.find((v) => v.o.every((val, i) => val === this.selected[i])) || null;
    }

    missingIndex() {
      return this.selected.findIndex((v) => v === null);
    }

    reference() {
      return this.variant || this.candidates().find((v) => v.available) || this.candidates()[0] || this.data.variants[0];
    }

    total(price) {
      if (this.data.mode === 'pack') return packTotal(price, this.quantity, this.data.tiers);
      return price * this.quantity;
    }

    update({ user = false, changed = -1 } = {}) {
      const variant = this.variant;
      const ref = this.reference();

      /* Selbstheilung: gewählter Wert existiert mit den anderen Optionen nicht mehr → zurücksetzen */
      if (!variant && !this.selected.includes(null) && changed >= 0) {
        this.selected.forEach((val, i) => {
          if (i === changed || val === null) return;
          const exists = this.data.variants.some((v) => v.o[i] === val && v.o.every((x, j) => j === i || this.selected[j] === null || x === this.selected[j]));
          if (!exists) {
            this.selected[i] = null;
            const group = this.groupAt(i);
            const input = group && group.querySelector('input:checked');
            if (input) input.checked = false;
          }
        });
      }

      this.updateTiles();
      this.updateOptionValues();

      if (variant) {
        if (this.idInput && String(this.idInput.value) !== String(variant.id)) {
          this.idInput.value = variant.id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (user) this.updateUrl(variant);
      }

      if (this.qtyUnit) {
        const unit = this.quantity === 1 ? 'Pack' : 'Packs';
        if (this.qtyUnit.textContent !== unit) this.qtyUnit.textContent = unit;
      }
      this.updatePrices(ref);
      this.updateButton(variant, ref);

      /* Galerie: bei neuem Variantenbild dorthin springen */
      const mediaSource = variant || this.candidates().find((v) => v.media) || null;
      const media = mediaSource && mediaSource.media ? String(mediaSource.media) : null;
      if (user && media && media !== this.lastMedia && this.gallery && this.gallery.showMedia) this.gallery.showMedia(media);
      if (media && user) this.lastMedia = media;

      if (user) {
        document.dispatchEvent(
          new CustomEvent('gcs:variant:change', { detail: { sectionId: this.sectionId, variant, quantity: this.quantity } })
        );
      }
      this.dispatchEvent(new CustomEvent('gcs:product:update', { bubbles: false }));
    }

    updateTiles() {
      const showPre = this.data.variants.some((v) => v.available && !v.preorder) && !this.data.preorderProduct;
      this.groups.forEach((group) => {
        const pos = Number(group.dataset.gcsOption) - 1;
        const isSize = group.hasAttribute('data-size');
        const rows = Array.from(group.querySelectorAll('input[type="radio"]')).map((input) => {
          const matches = this.data.variants.filter(
            (v) => v.o[pos] === input.value && this.selected.every((val, i) => i === pos || val === null || v.o[i] === val)
          );
          let state = '';
          if (!matches.length) state = 'missing';
          else if (!matches.some((v) => v.available)) state = 'soldout';
          else if (!matches.some((v) => v.available && !v.preorder)) state = 'preorder';
          return { input, state };
        });
        /* „Vorbestellung“ nur an Größen und nur, wenn es in der Gruppe auch Ware auf Lager gibt */
        const live = rows.filter((r) => r.state !== 'missing' && r.state !== 'soldout');
        const allPre = live.length > 0 && live.every((r) => r.state === 'preorder');
        rows.forEach(({ input, state }) => {
          if (state === 'preorder' && (!showPre || !isSize || allPre)) state = '';
          const label = input.closest('.gcs-tile');
          const sub = label && label.querySelector('[data-gcs-tile-sub]');
          input.disabled = state === 'missing';
          if (label) {
            label.classList.toggle('is-missing', state === 'missing');
            label.classList.toggle('is-unavailable', state === 'soldout');
            label.classList.toggle('is-preorder', state === 'preorder');
          }
          if (sub) sub.textContent = state === 'soldout' ? 'Ausverkauft' : state === 'preorder' ? 'Vorbestellung' : '';
        });
      });
    }

    updateOptionValues() {
      this.groups.forEach((group) => {
        const pos = Number(group.dataset.gcsOption) - 1;
        const out = group.querySelector('[data-gcs-option-value]');
        if (!out) return;
        const checked = group.querySelector('input:checked');
        out.textContent = this.selected[pos] !== null && checked ? checked.dataset.display || checked.value : '';
      });
    }

    updatePrices(ref) {
      if (!ref) return;
      /* Kopfpreis (1 Pack / 1 Stück) */
      if (this.headPrice) {
        const pp = this.headPrice.querySelector('[data-gcs-price-pp]');
        const pairs = pp ? Number(pp.dataset.pairs) || 0 : 0;
        const now = this.headPrice.querySelector('[data-gcs-price-now]');
        const onSale = ref.compare > ref.price;
        const wrap = this.headPrice.querySelector('[data-gcs-price]');
        if (now) {
          now.innerHTML = (onSale ? '<span class="gcs-sr">Angebotspreis </span>' : '') + esc(money(ref.price));
        }
        let was = this.headPrice.querySelector('[data-gcs-price-was]');
        if (onSale) {
          if (!was && now) {
            was = document.createElement('s');
            was.className = 'gcs-price__was';
            was.setAttribute('data-gcs-price-was', '');
            now.after(was);
          }
          if (was) was.innerHTML = '<span class="gcs-sr">Normalpreis </span>' + esc(money(ref.compare));
        } else if (was) {
          was.remove();
        }
        if (wrap) wrap.classList.toggle('gcs-price--sale', onSale);
        if (pp && pairs > 0) pp.textContent = money(Math.round(ref.price / pairs)) + ' pro Paar';
      }

      /* Pack-Kacheln */
      if (this.packs) {
        this.packs.querySelectorAll('[data-pack]').forEach((tile) => {
          const n = Number(tile.dataset.pack);
          const total = packTotal(ref.price, n, this.data.tiers);
          const pairs = (this.data.pairs || 2) * n;
          const totalEl = tile.querySelector('[data-pack-total]');
          const ppEl = tile.querySelector('[data-pack-pp]');
          const shipEl = tile.querySelector('[data-pack-ship]');
          if (totalEl) totalEl.textContent = money(total);
          /* PDP v2: ab 3 Packs „nur … pro Paar“ (wie Liquid) */
          if (ppEl) ppEl.textContent = (n >= 3 ? 'nur ' : '') + money(Math.round(total / pairs)) + ' pro Paar';
          if (shipEl) shipEl.hidden = !(this.data.freeThreshold > 0 && total >= this.data.freeThreshold);
        });
      }
    }

    get soldOutAll() {
      return !this.data.variants.some((v) => v.available);
    }

    labelFor(variant) {
      if (!variant && this.soldOutAll) return 'Ausverkauft';
      if (!variant) {
        const i = this.missingIndex();
        if (i >= 0) {
          const group = this.groupAt(i);
          const name = (group && group.dataset.label) || 'Größe';
          return `${name} wählen`;
        }
        return 'Nicht verfügbar';
      }
      if (!variant.available) return 'Ausverkauft';
      if (variant.preorder) return 'Vorbestellen';
      return 'In den Warenkorb';
    }

    /* P6: Rabatt-Box der gewählten Stufe rastet kurz ein (CSS-Animation, bei „Bewegung reduzieren“ aus) */
    snapDeal(input) {
      const box = input.closest('.gcs-pack') && input.closest('.gcs-pack').querySelector('.gcs-pack__deal');
      if (!box) return;
      box.classList.remove('is-snap');
      void box.offsetWidth;
      box.classList.add('is-snap');
    }

    /* BF-Streichpreis: echter Vergleichspreis der Referenzvariante × Menge, nur wenn größer als der Preis */
    wasFor(ref) {
      const bf = this.data.bf || {};
      if (!bf.strike || !ref || !(ref.compare > ref.price)) return '';
      return money(ref.compare * this.quantity);
    }

    updateButton(variant, ref) {
      const label = this.labelFor(variant);
      const price = ref ? money(this.total(ref.price)) : '';
      const was = this.wasFor(ref);
      const pairs = this.data.mode === 'pack' ? (this.data.pairs || 2) * this.quantity : 0;
      const ppCents = ref && pairs > 0 ? Math.round(this.total(ref.price) / pairs) : null;
      const soldout = (!!variant && !variant.available) || (!variant && this.soldOutAll);
      const missing = !variant && this.missingIndex() >= 0;
      if (this.btn && !this.busy) {
        this._btnState = { label, price, was };
        this.paintButton();
        if (ppCents !== null) this.countPp(ppCents);
        this.btn.disabled = soldout || (!variant && !missing);
        this.btn.classList.toggle('is-choose', missing);
      }
      if (this.bisBtn) {
        const hasBis = !!(window.BIS || window.BISPopover || document.querySelector('script[src*="backinstock"]'));
        /* „Benachrichtigen“ braucht eine gewählte Variante */
        this.bisBtn.hidden = !(soldout && !!variant && hasBis);
        if (variant) this.bisBtn.setAttribute('data-variant-id', variant.id);
        /* QA: Das BIS-Script (ScriptTag) lädt erst nach diesem Script. Bei vorausgewählter ausverkaufter Variante
           (z. B. HIGHPERFORMANCE PACK) blieb „Benachrichtigen“ deshalb bis zum nächsten Klick versteckt. */
        if (soldout && !hasBis) this.waitForBis();
      }
      /* Lieferhinweis (PDP v2): instock = grüner Punkt + Ländertext, preorder = Vorbestellungs-Hinweis, soldout = nichts.
         Ohne gewählte Größe zählt das Produkt (wie Liquid). */
      if (this.note) {
        let state;
        if (variant) {
          if (!variant.available) state = 'soldout';
          else if (this.data.preorderProduct || variant.preorder) state = 'preorder';
          else state = 'instock';
        } else if (missing) {
          const avail = this.data.variants.filter((v) => v.available);
          if (!this.data.preorderProduct && avail.some((v) => !v.preorder)) state = 'instock';
          else state = avail.length ? 'preorder' : 'soldout';
        } else {
          state = 'soldout';
        }
        const texts = this.data.texts || {};
        this.note.dataset.state = state;
        this.note.hidden = state === 'soldout';
        if (this.noteText) {
          this.noteText.textContent = state === 'preorder' ? texts.preorder : state === 'instock' ? texts.instock || texts.delivery : '';
        }
      }
      if (!soldout && this.errorEl && !this.errorEl.hidden && this.errorEl.dataset.kind === 'soldout') this.hideError();
    }

    /* A3 (Review-Call 08.10.2026): Lieferhinweis hält die Höhe beim Wechsel Auf Lager <-> Vorbestellung. Beide Texte
       werden in einer unsichtbaren Kopie in der aktuellen Breite gemessen, die größere Höhe wird Mindesthöhe. Neu bei
       Breitenwechsel (Drehen, Fenster). Nur wenn das Produkt beide Zustände hat. */
    reserveNote() {
      if (!this.note || !this.noteText || this._noteRo) return;
      const texts = this.data.texts || {};
      const avail = this.data.variants.filter((v) => v.available);
      const mixed = !this.data.preorderProduct && avail.some((v) => v.preorder) && avail.some((v) => !v.preorder);
      if (!mixed || !texts.preorder) return;
      let lastWidth = 0;
      const measure = () => {
        const width = this.note.getBoundingClientRect().width;
        if (!width || Math.abs(width - lastWidth) < 1) return;
        lastWidth = width;
        const probe = this.note.cloneNode(true);
        probe.hidden = false;
        probe.removeAttribute('data-gcs-note');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:${width}px;min-height:0;margin:0`;
        const text = probe.querySelector('[data-gcs-note-text]');
        this.note.parentElement.appendChild(probe);
        let max = 0;
        [['instock', texts.instock || texts.delivery], ['preorder', texts.preorder]].forEach(([state, t]) => {
          probe.dataset.state = state;
          if (text) text.textContent = t || '';
          max = Math.max(max, probe.getBoundingClientRect().height);
        });
        probe.remove();
        this.note.style.minHeight = max ? `${Math.ceil(max)}px` : '';
      };
      measure();
      if ('ResizeObserver' in window) {
        this._noteRo = new ResizeObserver(() => measure());
        this._noteRo.observe(this.note);
      }
    }

    waitForBis() {
      if (this._bisTimer) return;
      let tries = 0;
      this._bisTimer = setInterval(() => {
        tries += 1;
        const ready = !!(window.BIS || window.BISPopover || document.querySelector('script[src*="backinstock"]'));
        if (ready || tries > 40) {
          clearInterval(this._bisTimer);
          this._bisTimer = null;
          if (ready) this.updateButton(this.variant, this.reference());
        }
      }, 250);
    }

    paintButton() {
      const state = this._btnState;
      if (!state || !this.btn) return;
      const now = Date.now();
      if (!this._paintWindow || now - this._paintWindow > 1000) {
        this._paintWindow = now;
        this._paintCount = 0;
      }
      if (++this._paintCount > 30) return;
      const broken =
        !this.btn.contains(this.btnLabel) ||
        !this.btn.contains(this.btnPrice) ||
        (this.hasPp && !this.btn.contains(this.btnPp)) ||
        (this.hasWas && !this.btn.contains(this.btnWas));
      if (broken) {
        this.btn.innerHTML =
          '<span class="gcs-buy__label" data-gcs-atc-label></span><span class="gcs-buy__sum">' +
          (this.inline ? '<span class="gcs-buy__sep gcs-buy__sep--lead" aria-hidden="true">·</span>' : '') +
          (this.hasWas ? '<s class="gcs-buy__was" data-gcs-atc-was hidden></s>' : '') +
          '<span class="gcs-buy__total" data-gcs-atc-price></span>' +
          (this.hasPp && this.inline ? '<span class="gcs-buy__sep" aria-hidden="true">·</span>' : '') +
          (this.hasPp ? '<span class="gcs-buy__pp" data-gcs-atc-pp></span>' : '') +
          '</span>';
        this.btnLabel = this.btn.querySelector('[data-gcs-atc-label]');
        this.btnPrice = this.btn.querySelector('[data-gcs-atc-price]');
        this.btnPp = this.btn.querySelector('[data-gcs-atc-pp]');
        this.btnWas = this.btn.querySelector('[data-gcs-atc-was]');
      }
      if (this.btnWas) {
        const was = state.was || '';
        /* Vergleich über data-v statt innerHTML (Leerzeichen-Entities), Attribute löst der Guard nicht aus */
        if (this.btnWas.dataset.v !== was) {
          this.btnWas.innerHTML = was ? '<span class="gcs-sr">Normalpreis </span>' + esc(was) : '';
          this.btnWas.dataset.v = was;
        }
        if (this.btnWas.hidden !== !was) this.btnWas.hidden = !was;
      }
      const label = this.btn.classList.contains('is-added') ? 'Hinzugefügt' : state.label;
      if (this.btnLabel.textContent !== label) this.btnLabel.textContent = label;
      if (this.btnPrice.textContent !== state.price) this.btnPrice.textContent = state.price;
      if (this.btnPp && this._ppShown != null) {
        const pp = `${money(this._ppShown)} pro Paar`;
        if (this.btnPp.textContent !== pp) this.btnPp.textContent = pp;
      }
    }

    /* P6: Preis pro Paar zählt beim Pack-Wechsel weich auf den neuen Wert (420 ms, ease-out), ohne Bewegung sofort */
    countPp(target) {
      if (!this.btnPp) return;
      const from = this._ppShown == null ? target : this._ppShown;
      cancelAnimationFrame(this._ppRaf);
      if (from === target || reduceMotion()) {
        this._ppShown = target;
        this.paintButton();
        return;
      }
      const start = performance.now();
      const dur = 420;
      const step = (t) => {
        const k = Math.min(1, (t - start) / dur);
        const eased = 1 - Math.pow(1 - k, 3);
        this._ppShown = Math.round(from + (target - from) * eased);
        if (this.btnPp) this.btnPp.textContent = `${money(this._ppShown)} pro Paar`;
        if (k < 1) this._ppRaf = requestAnimationFrame(step);
      };
      this._ppRaf = requestAnimationFrame(step);
      /* Absicherung: Läuft requestAnimationFrame nicht (Hintergrund-Tab, In-App-Browser), steht nach der Dauer trotzdem der Endwert */
      clearTimeout(this._ppTimer);
      this._ppTimer = setTimeout(() => {
        if (this._ppShown === target) return;
        cancelAnimationFrame(this._ppRaf);
        this._ppShown = target;
        this.paintButton();
      }, dur + 80);
    }

    updateUrl(variant) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {
        /* ignorieren */
      }
    }

    /* Größe fehlt: sanft hinscrollen, Gruppe markieren, Hinweis (Impeccable P3: ruhige Führung statt Fehler-Rot) */
    promptSelection() {
      const i = this.missingIndex();
      const group = this.groupAt(i);
      if (!group) return;
      const name = group.dataset.name || group.dataset.label || 'Größe';
      const error = group.querySelector('[data-gcs-option-error]');
      if (error) {
        error.textContent = `Bitte wähl deine ${name}.`;
        error.hidden = false;
      }
      group.classList.remove('is-attention');
      void group.offsetWidth;
      group.classList.add('is-attention');
      const rect = group.getBoundingClientRect();
      const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gcs-header-offset'), 10) || 0;
      const inView = rect.top >= offset + 8 && rect.bottom <= window.innerHeight - 90;
      if (!inView) {
        window.scrollTo({
          top: window.scrollY + rect.top - offset - 24,
          behavior: reduceMotion() ? 'auto' : 'smooth',
        });
      }
      const first = group.querySelector('input:not(:disabled)');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), inView ? 0 : 450);
    }

    clearAttention(group) {
      group.classList.remove('is-attention');
      const error = group.querySelector('[data-gcs-option-error]');
      if (error) error.hidden = true;
    }

    showError(message, kind = '') {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.dataset.kind = kind;
      this.errorEl.hidden = false;
    }

    hideError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    setBusy(on, extra) {
      this.busy = on;
      [this.btn, extra].forEach((b) => {
        if (!b) return;
        b.setAttribute('aria-busy', on ? 'true' : 'false');
        if (!on) b.removeAttribute('aria-busy');
      });
    }

    /* Positions-Eigenschaften, die Apps ins Formular schreiben (Nachbesserung P, 02.10.2026): Preorder Now Wolf setzt
       bei Vorbestellungs-Varianten properties[Typ]=Vorbestellung und nimmt es beim Wechsel wieder heraus. Das Live-Theme
       schickt das Formular und damit die Eigenschaft mit; wir übernehmen sie in GCS.cart.add (Hauptbutton, Sticky,
       Pack-Selector). Kaching (properties[__kaching_bundles]) bleibt bewusst draußen: der Mengenrabatt greift ohne. */
    formProperties() {
      if (!this.form) return null;
      const props = {};
      new FormData(this.form).forEach((value, key) => {
        const m = /^properties\[(.+)\]$/.exec(key);
        if (!m || /^__kaching/.test(m[1]) || typeof value !== 'string' || value === '') return;
        props[m[1]] = value;
      });
      return Object.keys(props).length ? props : null;
    }

    /* Öffentlich: product.buy('sticky') */
    async buy(source, triggerBtn) {
      if (this.busy) return;
      const variant = this.variant;
      if (!variant) {
        this.promptSelection();
        return;
      }
      if (!variant.available) {
        this.showError('Diese Auswahl ist gerade ausverkauft.', 'soldout');
        return;
      }
      const quantity = this.quantity;
      const src = source || (this.data.mode === 'pack' && quantity > 1 ? 'pack-selector' : 'pdp');
      this.hideError();

      if (!GCS.cart || typeof GCS.cart.add !== 'function') {
        if (this.form) {
          if (this.idInput) this.idInput.value = variant.id;
          HTMLFormElement.prototype.submit.call(this.form);
        }
        return;
      }

      this.setBusy(true, triggerBtn);
      try {
        const item = { id: variant.id, quantity };
        const properties = this.formProperties();
        if (properties) item.properties = properties;
        await GCS.cart.add([item], { source: src });
        this.flashSuccess(triggerBtn);
      } catch (error) {
        const message = (error && error.message) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
        this.showError(message);
        if (src === 'sticky' && GCS.toast) GCS.toast(message, { type: 'error' });
      } finally {
        this.setBusy(false, triggerBtn);
        this.updateButton(this.variant, this.reference());
      }
    }

    flashSuccess(triggerBtn) {
      if (!this.btn) return;
      this.btn.classList.add('is-added');
      this.paintButton();
      if (triggerBtn) triggerBtn.classList.add('is-added');
      clearTimeout(this._successTimer);
      this._successTimer = setTimeout(() => {
        this.btn.classList.remove('is-added');
        if (triggerBtn) triggerBtn.classList.remove('is-added');
        this.updateButton(this.variant, this.reference());
        this.dispatchEvent(new CustomEvent('gcs:product:update'));
      }, 1600);
      this.dispatchEvent(new CustomEvent('gcs:product:update'));
    }

    /* Zusammenfassung für die Sticky-Leiste */
    summary() {
      const variant = this.variant;
      const ref = this.reference();
      const q = this.quantity;
      const packs = this.data.mode === 'pack' || (this.data.bf && this.data.bf.packUnit);
      const amount = packs ? (q === 1 ? '1 Pack' : `${q} Packs`) : `Menge ${q}`;
      const pct = this.data.mode === 'pack' && q >= 2 ? Number((this.data.tiers || {})[Math.min(q, 4)] || 0) : 0;
      /* A4: Preiszeile für den Sticky-Button, gleiche Rechnung wie der Kaufen-Button (packTotal / Paare) */
      const sum = ref ? this.total(ref.price) : null;
      const pairs = this.data.mode === 'pack' && this.data.pairs > 0 ? this.data.pairs * q : 0;
      const prices = sum == null ? '' : money(sum) + (this.hasPp && pairs > 0 ? ` · ${money(Math.round(sum / pairs))} pro Paar` : '');
      return {
        prices,
        was: this.wasFor(ref),
        pct,
        missing: !variant && this.missingIndex() >= 0 && !this.soldOutAll,
        label: this.btn && this.btn.classList.contains('is-added') ? 'Hinzugefügt' : this.labelFor(variant),
        disabled: (!!variant && !variant.available) || (!variant && this.soldOutAll),
        amount,
        price: ref ? money(this.total(ref.price)) : '',
      };
    }
  }

  /* ------------------------------------------------------------------ */
  /* <gcs-sticky-buy>                                                     */
  /* ------------------------------------------------------------------ */
  class GcsStickyBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.btn = this.querySelector('[data-gcs-sticky-btn]');
      this.label = this.querySelector('[data-gcs-sticky-label]');
      this.meta = this.querySelector('[data-gcs-sticky-meta]');
      this.prices = this.querySelector('[data-gcs-sticky-prices]');
      this.was = this.querySelector('[data-gcs-sticky-was]');
      /* away = am Kaufen-Button vorbeigescrollt (Button oberhalb des Bildes, Runde D) */
      this.state = { away: false, footer: false, drawer: false };
      /* <gcs-product> ist evtl. noch nicht aufgerüstet: kurz warten */
      const init = () => {
        this.product = document.getElementById(this.dataset.product);
        if (!this.product || !this.product._ready) return false;
        this.bind();
        return true;
      };
      if (!init()) {
        customElements.whenDefined('gcs-product').then(() => requestAnimationFrame(() => init() || setTimeout(init, 300)));
      }
    }

    bind() {
      const atc = this.product.querySelector('[data-gcs-atc]');
      if ('IntersectionObserver' in window && atc) {
        /* Runde D (David, 04.10.2026): sichtbar erst, wenn man am Kaufen-Button vorbeigescrollt ist (Button oberhalb
           des Bildes oder unter dem Header), nicht beim Laden, solange man ihn noch nicht erreicht hat. Der Wurzelbereich
           reicht nach unten unbegrenzt weit: „nicht im Bereich“ heißt damit genau „oberhalb“. So meldet der Observer auch
           einen Sprung von unterhalb nach ganz oben (z. B. Tipp auf die iOS-Statusleiste). Oben 56 px für den Header. */
        this.atcObserver = new IntersectionObserver(
          (entries) => {
            const e = entries[entries.length - 1];
            this.state.away = !e.isIntersecting;
            this.render();
          },
          { rootMargin: '-56px 0px 100000px 0px' }
        );
        this.atcObserver.observe(atc);
        const footer = document.querySelector('.gcs-footer') || document.querySelector('footer');
        if (footer) {
          this.footerObserver = new IntersectionObserver((entries) => {
            this.state.footer = entries[entries.length - 1].isIntersecting;
            this.render();
          });
          this.footerObserver.observe(footer);
        }
      }
      document.addEventListener('gcs:drawer:open', () => {
        this.state.drawer = true;
        this.render();
      });
      document.addEventListener('gcs:drawer:close', () => {
        this.state.drawer = false;
        this.render();
      });
      this.product.addEventListener('gcs:product:update', () => this.sync());
      this.btn.addEventListener('click', () => {
        const s = this.product.summary();
        if (s.missing) {
          this.product.promptSelection();
          return;
        }
        this.product.buy('sticky', this.btn);
      });
      this.sync();
    }

    sync() {
      const s = this.product.summary();
      if (this.label.textContent !== s.label) this.label.textContent = s.label;
      this.btn.disabled = s.disabled;
      this.btn.classList.toggle('is-added', s.label === 'Hinzugefügt');
      this.btn.classList.toggle('is-choose', s.missing);
      /* Menge, gewählte Stufe mit grüner Rabatt-Box (wie im Pack-Selector), Gesamtpreis. Die Größe steht in der
         Größenwahl; hier hat der Preis Vorrang (390 px: alles passt neben „In den Warenkorb“). Markup wie in Liquid. */
      const deal = s.pct > 0
        ? ` <span class="gcs-sticky__deal" data-gcs-sticky-deal><span class="gcs-sr">Du sparst ${s.pct}&nbsp;%</span><span aria-hidden="true">-${s.pct}%</span></span>`
        : '';
      /* A4: Preise stehen im Button (zweite Zeile), die Info-Zeile zeigt dann nur Menge und Rabatt-Box */
      if (this.prices && this.prices.textContent !== s.prices) this.prices.textContent = s.prices;
      /* BF: Streichpreis vor dem Preis (im Button oder, ohne Preis im Button, in der Info-Zeile) */
      if (this.was && this.was.dataset.v !== s.was) {
        this.was.innerHTML = s.was ? `<span class="gcs-sr">Normalpreis </span>${esc(s.was)}` : '';
        this.was.dataset.v = s.was;
        this.was.hidden = !s.was;
      }
      const wasMeta = s.was ? `<s class="gcs-sticky__was"><span class="gcs-sr">Normalpreis </span>${esc(s.was)}</s> ` : '';
      const html =
        `<span class="gcs-sticky__amount">${esc(s.amount)}</span>${deal}` +
        (this.prices ? '' : `<span class="gcs-sticky__sep" aria-hidden="true">·</span>${wasMeta}<strong class="gcs-sticky__price">${esc(s.price)}</strong>`);
      if (this._metaHtml === html) return;
      this._metaHtml = html;
      this.meta.innerHTML = html;
      /* P6: Rabatt-Box rastet bei neuer Stufe kurz ein */
      if (s.pct > 0 && this._pct !== s.pct && this._pct !== undefined) {
        const box = this.meta.querySelector('[data-gcs-sticky-deal]');
        if (box) box.classList.add('is-snap');
      }
      this._pct = s.pct;
    }

    render() {
      /* Nur mobil (< 990 px): Desktop blendet die Leiste per CSS aus, dann auch keine App-Symbole verschieben */
      if (!this.mq) {
        this.mq = window.matchMedia('(max-width: 989px)');
        if (this.mq.addEventListener) this.mq.addEventListener('change', () => this.render());
      }
      const show = this.mq.matches && this.state.away && !this.state.footer && !this.state.drawer;
      if (show === this.visible) return;
      this.visible = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.toggleAttribute('inert', !show);
      document.documentElement.classList.toggle('gcs-has-sticky', show);
    }
  }

  /* ------------------------------------------------------------------ */
  /* <gcs-product-recommendations>                                        */
  /* ------------------------------------------------------------------ */
  class GcsProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._ready || !this.dataset.url || !this.dataset.productId) return;
      // Black Month: Liste kommt fertig aus Liquid (Kategorie nach Bestand), nicht per Recommendations-API ersetzen
      if (this.dataset.static === 'true') return;
      this._ready = true;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 700px 0px' }
      );
      this.observer.observe(this);
    }

    async fetchIntent(intent) {
      const response = await fetch(`${this.dataset.url}&intent=${intent}`, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('gcs-product-recommendations');
    }

    async load() {
      try {
        /* Review-Call 24.10.2026: zuerst „related“ (lernt aus Käufen), sonst „complementary“; data-intent dreht um */
        const order = this.dataset.intent === 'complementary' ? ['complementary', 'related'] : ['related', 'complementary'];
        let el = await this.fetchIntent(order[0]);
        if (!el || Number(el.dataset.count || 0) === 0) el = await this.fetchIntent(order[1]);
        if (!el) throw new Error('leer');
        el.querySelectorAll(`[data-product-id="${this.dataset.productId}"]`).forEach((n) => {
          const item = n.closest('.gcs-reco__item') || n;
          item.remove();
        });
        if (!el.querySelector('.gcs-reco__item')) throw new Error('leer');
        this.innerHTML = el.innerHTML;
      } catch (e) {
        const section = this.closest('.shopify-section') || this.closest('[data-gcs-reco-section]');
        if (section) section.hidden = true;
      }
    }
  }

  const define = (name, cls) => {
    if (!customElements.get(name)) customElements.define(name, cls);
  };
  define('gcs-gallery', GcsGallery);
  define('gcs-product', GcsProduct);
  define('gcs-sticky-buy', GcsStickyBuy);
  define('gcs-product-recommendations', GcsProductRecommendations);
})();
